import { CicStatus, cicStatusSchema } from '@sophocles/entities/CicStatus/cicStatusRecord';
import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_CIC_STATUSES = 'RECEIVE_CIC_STATUSES';
function receiveCicStatuses(json) {
  return {
    type: RECEIVE_CIC_STATUSES,
    cicStatuses: mapListToRecords(json, CicStatus),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CIC_STATUS = 'REQUEST_CIC_STATUS';
function requestCicStatus(cicStatus_id) {
  return {
    type: REQUEST_CIC_STATUS,
    cicStatus_id,
  };
}

export const REQUEST_CIC_STATUS_FOR_UNIT = 'REQUEST_CIC_STATUS_FOR_UNIT';
function requestCicStatusForUnit(cic_id) {
  return {
    type: REQUEST_CIC_STATUS_FOR_UNIT,
    cic_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCicStatus(cicStatus_id) {
  return dispatch => {
    dispatch(requestCicStatus(cicStatus_id));
    return apiClient
      .get(`/cicstatus/${cicStatus_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'cicStatuses', cicStatusSchema))
      .then(json => dispatch(receiveCicStatuses(json.entities.cicStatuses)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CIC_STATUS)));
  };
}

export function fetchCicStatusForUnit(cic_id) {
  return dispatch => {
    dispatch(requestCicStatusForUnit(cic_id));
    return apiClient
      .get('/cicstatus/', { params: { cic: cic_id } })
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'cicStatuses', cicStatusSchema))
      .then(json => dispatch(receiveCicStatuses(json.entities.cicStatuses)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CIC_STATUS_FOR_UNIT)));
  };
}

/* Edit Actions */
export const EDIT_CIC_STATUS = 'EDIT_CIC_STATUS';
export function editCicStatus(cicStatus_id) {
  return {
    type: EDIT_CIC_STATUS,
    cicStatus: cicStatus_id,
  };
}

export function patchCicStatus(cicStatus_id, values) {
  return dispatch => {
    dispatch(editCicStatus(cicStatus_id));
    return apiClient
      .patch(`/cicstatus/${cicStatus_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, cicStatusSchema))
      .then(json => dispatch(receiveCicStatuses(json.entities.cicStatuses)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_CIC_STATUS)));
  };
}

/* Create Actions */
export const CREATE_CIC_STATUS = 'CREATE_CIC_STATUS';
function sayCreateCicStatus(values) {
  return {
    type: CREATE_CIC_STATUS,
    values: values,
  };
}

export function createCicStatus(values) {
  return dispatch => {
    dispatch(sayCreateCicStatus(values));
    return apiClient
      .post(`/cicstatus/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, cicStatusSchema))
      .then(json => dispatch(receiveCicStatuses(json.entities.cicStatuses)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_CIC_STATUS)));
  };
}

/* Delete Actions */
export const DELETE_CIC_STATUS = 'DELETE_CIC_STATUS';
function sayDeleteCicStatus(cicStatus_id) {
  return {
    type: DELETE_CIC_STATUS,
    cicStatus: cicStatus_id,
  };
}

export function deleteCicStatus(cicStatus_id) {
  return dispatch =>
    apiClient
      .delete(`/cicstatus/${cicStatus_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteCicStatus(cicStatus_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_CIC_STATUS)));
}
